import Can from './can';
import Module from './module';

export {
  Can,
  Module,
};



/** WEBPACK FOOTER **
 ** ./client/components/can/index.js
 **/